import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, OnChanges, SimpleChanges } from '@angular/core';
import { ColorInjector } from '../ColorInjector';

@Component({
    selector: 'usimweb-button',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <button
      [style.color]="textColor"
      [style.background-color]="color"
      [style.width]="widthPx"
      [style.box-shadow]="shadow"
      [disabled]="disabled"
      mat-raised-button
      [matTooltip]="toolTip"
      type="button"
      (click)="clickEvent()">
      {{ btnText }}
    </button>
  `,
    standalone: false
})
export class ButtonComponent extends ColorInjector implements OnChanges {
  @Input()
  set text(name: string) {
    this.btnText = name;
  }
  get name(): string {
    return this.text;
  }

  @Input() toolTip: string = '';

  @Input() color: string = this.mainColor || '';

  @Input() textColor: string = 'white';

  @Input() width!: number;

  @Input() fullSize: boolean = false;

  @Input() disabled: boolean = false;

  @Output() btnClick: EventEmitter<any> = new EventEmitter<any>();

  public btnText: string = '';

  public shadow = '0px 2px 6px #00000040';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled']) {
      if (this.disabled) {
        this.textColor = '#dddddd';
        this.color = 'white';
      } else {
        this.textColor = 'white';
        this.color = this.mainColor || '';
      }
    }
  }

  public clickEvent() {
    if (!this.disabled) {
      this.btnClick.emit();
    }
  }

  public get widthPx() {
    if (this.fullSize) {
      return '100%';
    }
    if (this.width) {
      return this.width + 'px';
    }
    return null;
  }
}
